import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import { REGOLA_PASSWORD, validaPassword, LUNGHEZZA_MINIMA_PASSWORD } from '../utils/regolaPassword';

export default function SetupStudio() {
  const [form, setForm] = useState({ setup_token: '', email: '', password: '', nome: '', cognome: '' });
  const [errore, setErrore] = useState('');
  const [caricamento, setCaricamento] = useState(false);
  const { setUtente } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    const erroreRegola = validaPassword(form.password, form.email);
    if (erroreRegola) return setErrore(erroreRegola);
    setCaricamento(true);
    try {
      const { setup_token, ...dati } = form;
      const res = await api.post('/auth/setup-studio', dati, { headers: { 'X-Setup-Token': setup_token } });
      localStorage.setItem('token', res.data.token);
      setUtente(res.data.utente);
      navigate('/');
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore di connessione');
    } finally {
      setCaricamento(false);
    }
  };

  const aggiorna = (campo, valore) => setForm(prev => ({ ...prev, [campo]: valore }));

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoBox}>
          <img src="/logo_boldrin.svg" alt="Studio Boldrin" style={styles.logo} />
        </div>
        <div style={styles.divider}></div>
        <h2 style={styles.title}>Setup Iniziale</h2>
        <p style={styles.subtitle}>Crea l'account amministratore dello studio</p>
        <form onSubmit={handleSubmit}>
          {errore && <div style={styles.errore}>{errore}</div>}
          <div style={styles.campo}>
            <label style={styles.label}>Token di installazione</label>
            <input type="password" value={form.setup_token} onChange={e => aggiorna('setup_token', e.target.value)} required style={styles.input} placeholder="SETUP_TOKEN del file .env" />
          </div>
          <div style={styles.row}>
            {['nome', 'cognome'].map(campo => (
              <div key={campo} style={styles.campo}>
                <label style={styles.label}>{campo.charAt(0).toUpperCase() + campo.slice(1)}</label>
                <input type="text" value={form[campo]} onChange={e => aggiorna(campo, e.target.value)} required style={styles.input} />
              </div>
            ))}
          </div>
          <div style={styles.campo}>
            <label style={styles.label}>Email</label>
            <input type="email" value={form.email} onChange={e => aggiorna('email', e.target.value)} required style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label style={styles.label}>Password</label>
            <input type="password" value={form.password} onChange={e => aggiorna('password', e.target.value)} required minLength={LUNGHEZZA_MINIMA_PASSWORD} style={styles.input} />
            <small style={{ color: '#888', fontSize: '0.75rem' }}>{REGOLA_PASSWORD}</small>
          </div>
          <button type="submit" disabled={caricamento} style={styles.bottone}>
            {caricamento ? 'Creazione...' : 'Crea Account Studio'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#232323' },
  card: { background: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.3)', width: '100%', maxWidth: '450px' },
  logoBox: { textAlign: 'center', marginBottom: '1rem' },
  logo: { height: '40px' },
  divider: { height: '3px', background: '#D1D179', width: '40px', margin: '0 auto 1.2rem', borderRadius: '2px' },
  title: { margin: 0, fontSize: '1.1rem', color: '#232323', textAlign: 'center', fontWeight: 600 },
  subtitle: { color: '#888', textAlign: 'center', marginBottom: '1.5rem', fontSize: '0.85rem' },
  campo: { marginBottom: '1rem', flex: 1 },
  row: { display: 'flex', gap: '1rem' },
  label: { fontSize: '0.8rem', color: '#555', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' },
  input: { width: '100%', padding: '0.7rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box', marginTop: '0.3rem' },
  bottone: { width: '100%', padding: '0.8rem', background: '#232323', color: 'white', border: 'none', borderRadius: '6px', fontSize: '0.95rem', cursor: 'pointer', marginTop: '0.5rem', fontWeight: 600 },
  errore: { background: '#fef2f2', color: '#b91c1c', padding: '0.7rem', borderRadius: '6px', marginBottom: '1rem', textAlign: 'center', fontSize: '0.85rem', border: '1px solid #fecaca' },
};
